import { useField, useFormikContext } from "formik";
import Select from "react-select";
import { components } from "react-select";
import CreatableSelect from 'react-select/creatable';

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff !important", // Change the background color of the control
    borderColor: state.isFocused ? "#c4c4c433" : "#c4c4c433", // Change border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #c4c4c433" : null, // Optional: Change shadow on focus
    borderRadius: "10px",
    height: "50px",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
    fontFamily: "proxima nova",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    // backgroundColor: state.isSelected
    //   ? "#007BFF"
    //   : state.isFocused
    //   ? "#e2e2e2"
    //   : "#f0f0f0",
    color: state.isSelected ? "#000" : "#000", // Change text color based on selection
    // borderBottom: "1px solid #ddd",
    "&:hover": {
      // backgroundColor: "#007BFF",
      color: "#000", // Change text color on hover
    },
  }),
  menuPortal: provided => ({ ...provided, zIndex: 999999 })
};

const SelectDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
      >
        <path
          d="M6.99995 7.4521L0.0273438 0.479492H13.9726L6.99995 7.4521Z"
          fill="#1C1B1F"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

export const AppSelect2Field = ({
  option,
  placeholder,
  cstmOption = undefined,
  name,
  handleBlur,
  onChange,
  creatable,
  defaultValue,
  isLoading,
  isDisabled
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext() || {};
  const [field, meta] = name ? useField(name) : [];

  const handleFieldChange = (selected) => {
    name &&
      typeof setFieldValue === "function" &&
      setFieldValue(name, selected);

    typeof onChange === "function" && onChange(selected);
  }

  const IndicatorSeparator = () => {
    return null;
  };

  const options = option;
  const optionProps = { SelectDropdownIndicator, IndicatorSeparator };
  if (cstmOption) {
    optionProps.Option = cstmOption;
  }

  const renderComponent = () => {
    return (
      creatable ? (
        <CreatableSelect
          // isClearable 
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          classNamePrefix={"khan"}
          options={options}
          styles={selectCustomStyles}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          value={(field?.value || null)}
          defaultValue={defaultValue}
        />
      ) : (
        <Select
          placeholder={isLoading ? "Loading..." : placeholder}
          components={optionProps}
          classNamePrefix={"khan"}
          options={options}
          styles={selectCustomStyles}
          onChange={handleFieldChange}
          onBlur={handleBlur}
          value={(field?.value || null)}
          defaultValue={defaultValue}
          isDisabled={isDisabled}
          menuPortalTarget={document.body}
        />
      )
    )
  }
  return (
    <>
      {renderComponent()}
      {(meta?.touched && meta?.error) ? (
        <div className="error">{typeof meta?.error === "string" ? meta.error : meta?.error?.value}</div>
      ) : null}
    </>
  );
};